<div class="error-page">
  <div class="error-left-side">
    <div class="error-title">
      <span class="fa fa-exclamation-triangle"></span>
      <h2>{{ errormanifest.heading }}</h2>
    </div>
    <div class="content" [innerHtml]="errormanifest.content"></div>

    <div class="actions">
      <ng-container *ngFor="let action of errormanifest.actions">
        <a *ngIf="isRouterLinkAction(action)" [routerLink]="action.routerlink" class="action-link">
          {{ action.text }}
        </a>
        <a *ngIf="!isRouterLinkAction(action)" [href]="action.link" class="action-link link" target="_blank">
          {{ action.text }}
        </a>
      </ng-container>
    </div>
  </div>
  <div class="error-right-side">
    <img alt="lamp-img" src="./assets/images/Bayernwerk-streetlamp_off-49.png" class="error-lamp-image" />
  </div>
</div>
